import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import Colors from '../../ui/global/Colors';
import Icon from '../../ui/global/Icon';

const VideoContainer = styled.div<{ $colorMode: 'light' | 'dark'; }>`
    position: relative;
    width: fit-content;
    max-width: 100%;
    border-radius: 4px;
    border: 1px solid ${(props) => (props.$colorMode === 'dark' ? Colors.grey8 : Colors.grey2)};
    overflow: hidden;
    margin: 40px auto 100px auto;

    @media (max-width: 768px) {
        margin: 20px auto 60px auto;
    }
`;

const StyledVideo = styled.video`
    display: block;
    width: 100%;
    max-width: 1024px;
    height: auto;
    max-height: 85vh;
`;

interface VideoPlayerProps {
    videoUrl: string;
    autoplay?: boolean;
    loop?: boolean;
    colorMode?: 'light' | 'dark';
    captions?: string;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ videoUrl, autoplay = true, loop = true, colorMode = 'dark', captions }) => {
    const [hasBeenClicked, setHasBeenClicked] = useState(false);
    const videoRef = useRef<HTMLVideoElement>(null);

    const handleVideoClick = (event: React.MouseEvent<HTMLVideoElement>) => {
        if (!hasBeenClicked) {
            setHasBeenClicked(true);
            const videoElement = event.currentTarget;
            videoElement.muted = false; // Unmute the video

            // If the video was paused by the default click-to-toggle behavior, play it
            videoElement.play().catch(error => {
                // Handle potential errors where play() might be rejected (e.g., not user-initiated enough)
                console.error("Error attempting to play video after unmuting:", error);
            });

            // Prevent the default click-to-pause behavior for the first click
            event.preventDefault();
        }
        // For subsequent clicks, the browser's default controls will handle play/pause, so no further action is needed in the `else` block.
    };

    return (
        <VideoContainer $colorMode={colorMode}>
            <StyledVideo
                ref={videoRef}
                controls
                preload="auto"
                autoPlay={autoplay}
                muted={autoplay && !hasBeenClicked} // Mute initially if autoplay, until clicked
                loop={loop}
                onClick={handleVideoClick}
                controlsList="nodownload noremoteplayback noplaybackrate" disablePictureInPicture // Hide more menu
            >
                <source src={videoUrl} type="video/mp4" />
                {/* {captions && (
                    <track
                        kind="captions"
                        src={captions}
                        srcLang="en"
                        label="English"
                        default
                    />
                )} */}
            </StyledVideo>
        </VideoContainer>
    );
};

export default VideoPlayer;